import backend, {AGENTCORE_ENGINE_API, METRICS_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getMetricsUrl = (path, queryParam) => {
  if (!METRICS_API) {
    throw new Error('REACT_APP_METRICS_API is not configured.');
  }

  const query = queryString.stringify(queryParam);

  return `${METRICS_API}${path}?${query}`;
};

const queryDailyClientMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_count', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

const queryDailyClientLogsMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_logs', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

// Returns {snapshots} where each snapshot carries its own previous/current/next calendar
// periods (see periods.{previous,current,next}.{scheduled,actual}) for a single metric
// date. The Metrics backend owns every derived figure — hours, weighted hours, revenue,
// labour, gross profit/margin, and the current period's actual `throughDate` — so callers
// render its fields as-is rather than recomputing anything client side.
const queryMonthlyFinancialSnapshots = (dates) => {
  const url = getMetricsUrl('/metrics/financial/monthly_snapshot', {
    dates: (dates || []).join(','),
  });
  return backend.get(url);
};

// Returns the per-client monthly financial snapshot for a single metric date, calendar
// month, and period role: {metricDate, month, periodRole, clients, totals,
// lastEvaluatedKey}. The backend owns every derived figure (weighted hours, scheduled and
// actual revenue, holiday/pricing/rounding rules), so callers must render its fields as-is
// rather than recomputing them. Pass the lastEvaluatedKey returned by a previous page to
// fetch the next page.
const queryMonthlyClientSnapshot = ({date, month, lastEvaluatedKey} = {}) => {
  if (!date) {
    throw new Error('date is required to query the monthly client snapshot.');
  }

  if (!month) {
    throw new Error('month is required to query the monthly client snapshot.');
  }

  const queryParam = {date, month};

  // Pagination cursor is optional; DynamoDB may hand back either a string or an object,
  // so serialize objects before they hit the query string.
  if (lastEvaluatedKey) {
    queryParam.lastEvaluatedKey = typeof lastEvaluatedKey === 'string' ?
      lastEvaluatedKey :
      JSON.stringify(lastEvaluatedKey);
  }

  const url = getMetricsUrl('/metrics/financial/monthly_client_snapshot', queryParam);

  return backend.get(url);
};

// Agent report card rollups live in the AgentCore Engine API, not the metrics
// service, but share the metrics repo's daily_count date grammar.
const queryAgentReportCardMetrics = (dates, guideRn) => {
  const queryParam = {
    dates: dates.join(','),
    guideRn,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/metrics/agent_report_card?${query}`;

  return backend.get(url);
};

export default {
  queryAgentReportCardMetrics,
  queryDailyClientMetrics,
  queryDailyClientLogsMetrics,
  queryMonthlyClientSnapshot,
  queryMonthlyFinancialSnapshots,
};
